import React, { useState, useEffect } from 'react';
import PinPad from '../PinPad';

const ACTION_LABELS = {
  print_bill: 'Print Bill',
  bill_out: 'Bill Out'
};

export const CashierActionPinModal = ({
  isOpen,
  action,
  cashierName,
  onVerify,
  onClose,
  loading,
  error
}) => {
  const [pin, setPin] = useState('');
  const [localError, setLocalError] = useState(null);

  // When the parent propagates a new error, clear stale local state so the
  // submit button re-enables and the PIN input is ready for fresh entry.
  useEffect(() => {
    if (error) {
      setLocalError(null);
    }
  }, [error]);

  if (!isOpen) return null;

  const handleVerify = async (overridePin) => {
    const pinString = String(overridePin || pin).trim();
    if (pinString.length !== 4 || !/^\d{4}$/.test(pinString)) {
      setLocalError('PIN must be exactly 4 digits');
      return;
    }

    try {
      setLocalError(null);
      await onVerify?.(pinString);
      setPin('');
    } catch (verifyError) {
      setPin('');
      setLocalError(verifyError.message || 'Invalid PIN');
    }
  };

  const title = `Confirm: ${ACTION_LABELS[action] || 'Cashier Action'}`;

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="w-full max-w-xs rounded-xl bg-white p-5 shadow-2xl">
        <h3 className="text-lg font-bold text-gray-900">{title}</h3>
        <p className="mt-1 text-xs text-gray-500">{cashierName || 'Cashier'}</p>

        <div className="mt-4">
          <PinPad value={pin} onChange={setPin} onSubmit={handleVerify} error={localError || error} />
        </div>

        <div className="mt-4 flex gap-2">
          <button
            type="button"
            onClick={() => {
              setPin('');
              setLocalError(null);
              onClose?.();
            }}
            disabled={loading}
            className="flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => handleVerify(pin)}
            disabled={loading || pin.length !== 4}
            className="flex-1 rounded-lg bg-blue-600 px-3 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {loading ? 'Verifying...' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CashierActionPinModal;
